import { merge } from '../../../../utils/state';
import entity from './entity';
import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import { TYPES } from './actions';

const coreReducer = entity.getReducer();

const initialState = {
  ...ReduxRestEntity.initialState,
  data: [],
  isLoadingUpward: false,
  errorUpward: false,
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPES.GET_ALL_REQUEST_SUCCESS:
      return merge(state, {
        data: action.payload,
        isLoading: false,
        error: false,
      });
    case TYPES.GET_ALL_REQUEST_ERROR:
      return merge(state, {
        data: [],
        isLoading: false,
        error: action.payload,
      });
    case TYPES.GET_UPWARD_GRANT_REQUEST:
      return merge(state, {
        isLoadingUpward: true,
        errorUpward: false,
      });
    case TYPES.GET_UPWARD_GRANT_SUCCESS:
      return merge(state, {
        data: action.payload,
        isLoadingUpward: false,
        errorUpward: false,
      });
    case TYPES.GET_UPWARD_GRANT_ERROR:
      return merge(state, {
        isLoadingUpward: false,
        errorUpward: action.payload,
      });
    default:
      return coreReducer(state, action);
  }
};

export default reducer;
